import React, { memo } from 'react';

const Tooltip = memo(() => {
    return (
        <div className="w5-tooltip">
            <div className="w5-tooltip-content"></div>
            <div className="w5-tooltip-arrow" data-popper-arrow></div>
        </div>
    );
});

export default Tooltip;
